export default theme => ({
    container: {
        padding: '26px 30px'
    },
    label: {
        marginBottom: 4,
        fontSize: 12,
        fontWeight: 600,
        color: theme.palette.grey[900]
    },
    scoreLabel: {
        fontSize: 28,
        fontWeight: 700,
        color: theme.palette.grey[900]
    },
    rankLabel: {
        fontSize: 14,
        fontWeight: 700,
        letterSpacing: 0.1,
        whiteSpace: 'nowrap',
        color: theme.palette.grey[900],
        '& > span': {
            marginLeft: 15
        }
    },
    scoreWrapper: {
        width: 'calc(100% - 210px)'
    },
    empty: {
        fontSize: 47,
        fontWeight: 700
    }
});
